import { baseApi, extractData } from "../api/axiosConfig";

export const getAllDataPointAttributes = () =>
    baseApi
        .get("/dataPointAttribute")
        .then(extractData);

export const getDataPointAttributeById = dataPointAttributeId =>
    baseApi
        .get(`/dataPointAttribute/${dataPointAttributeId}`)
        .then(extractData);

export const addDataPointAttribute = data =>
    baseApi
        .post("/dataPointAttribute", data)
        .then(extractData);

export const addEmptyDataPointAttribute = () =>
    baseApi
        .post("/dataPointAttribute/nada")
        .then(extractData);

export const editDataPointAttribute = (dataPointAttributeId, data) =>
    baseApi
        .patch(`/dataPointAttribute/${dataPointAttributeId}`, data)
        .then(extractData);

export const deleteDataPointAttribute = dataPointAttributeId =>
    baseApi
        .delete(`/dataPointAttribute/${dataPointAttributeId}`)
        .then(extractData);

export const getR2ms = () =>
    baseApi
        .get("/dataPointAttribute/R2M")
        .then(extractData);

export const getContractMarketList = contractId =>
    baseApi
        .get("/dataPointAttribute/ContractMarket", {
            params: {
                contract_id: contractId
            }
        })
        .then(extractData);

export const getPivotAttributes = dataPointId =>
    baseApi
        .get("/dataPointAttribute/PivotAttributes", {
            params: {
                dataPointId
            }
        })
        .then(extractData);

export const getAttributesEnhanced = () =>
    baseApi
        .get("/dataPointAttribute/attributesEnhanced")
        .then(extractData);


// import axios from "axios";
//
// const BASE_URL = import.meta.env.VITE_BACKEND_URL;
//
// export const getAllDataPointAttributes = () =>
// axios.get(`${BASE_URL}/api/contramatic/dataPointAttribute`, {
//     headers: {
//         'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//     }
// })
//     //https://axios-http.com/docs/handling_errors
//     .catch(function (error) {
//         if (error.response) {
//             // The request was made and the server responded with a status code
//             // that falls out of the range of 2xx
//             console.log(error.response.data);
//             console.log(error.response.status);
//             console.log(error.response.headers);
//         } else if (error.request) {
//             // The request was made but no response was received
//             // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//             // http.ClientRequest in node.js
//             console.log(error.request);
//         } else {
//             // Something happened in setting up the request that triggered an Error
//             console.log('Error', error.message);
//         }
//         console.log(error.config);
//     });
//
// export const getDataPointAttributeById = (dataPointAttributeId) =>
//     axios.get(`${BASE_URL}/api/contramatic/dataPointAttribute/${dataPointAttributeId}`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export   const addDataPointAttribute = abcd =>
//  axios.post(`${BASE_URL}/api/contramatic/dataPointAttribute`, abcd, {
//      headers: {
//          'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//      }
//  })
//      .then(function (response) {
//          console.log(response);
//      })
//      .catch(function (error) {
//          if (error.response) {
//              // The request was made and the server responded with a status code
//              // that falls out of the range of 2xx
//              console.log(error.response.data);
//              console.log(error.response.status);
//              console.log(error.response.headers);
//          } else if (error.request) {
//              // The request was made but no response was received
//              // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//              // http.ClientRequest in node.js
//              console.log(error.request);
//          } else {
//              // Something happened in setting up the request that triggered an Error
//              console.log('Error', error.message);
//          }
//          console.log(error.config);
//      });
//
//
// export   const addEmptyDataPointAttribute = () =>
//     axios.post(`${BASE_URL}/api/contramatic/dataPointAttribute/nada`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         .then(function (response) {
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const editDataPointAttribute = (selectorDataPointAttributeId, data) =>
//     axios.patch(`${BASE_URL}/api/contramatic/dataPointAttribute/${selectorDataPointAttributeId}`, data, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         .then(function (response) {
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// //https://www.javatpoint.com/react-axios-delete-request-example except that it shows the wrong kinds of quotes - not backquotes
// export const deleteDataPointAttribute = selectorDataPointAttributeId =>
//     axios.delete(`${BASE_URL}/api/contramatic/dataPointAttribute/${selectorDataPointAttributeId}`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .then(function (response) {
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
//
// export const getR2ms = () =>
//     axios.get(`${BASE_URL}/api/contramatic/dataPointAttribute/R2M`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// export const getContractMarketList = (id) =>
//     axios.get(`${BASE_URL}/api/contramatic/dataPointAttribute/ContractMarket`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {contract_id: id}
//         })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getPivotAttributes = (dataPointId) =>
//     axios.get(`${BASE_URL}/api/contramatic/dataPointAttribute/PivotAttributes`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: { dataPointId: dataPointId}
//         })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
// //
// // // https://stackoverflow.com/questions/48980380/returning-data-from-axios-api#48980526
// // export function getPivotAttributes(dataPointId) {
// //     return     axios.get(`${BASE_URL}/api/contramatic/dataPointAttribute/PivotAttributes`
// //         ,
// //         {
// //             headers: {
// //                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
// //             },
// //             params: {
// //                 dataPointId: dataPointId
// //             }
// //         }
// //     )      //https://axios-http.com/docs/handling_errors
// //         .catch(function (error) {
// //             if (error.response) {
// //                 // The request was made and the server responded with a status code
// //                 // that falls out of the range of 2xx
// //                 console.log(error.response.data);
// //                 console.log(error.response.status);
// //                 console.log(error.response.headers);
// //             } else if (error.request) {
// //                 // The request was made but no response was received
// //                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
// //                 // http.ClientRequest in node.js
// //                 console.log(error.request);
// //             } else {
// //                 // Something happened in setting up the request that triggered an Error
// //                 console.log('Error', error.message);
// //             }
// //             console.log(error.config);
// //         })};
//
// export const getAttributesEnhanced = () =>
//     axios.get(`${BASE_URL}/api/contramatic/dataPointAttribute/attributesEnhanced`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
